import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import { extensionDecorator, MarkExtension, ExtensionTag, isElementDomNode, isString, toggleMark, markInputRule } from '@remirror/core';

var _dec, _class, _temp;
var BoldExtension = (_dec = /*#__PURE__*/extensionDecorator({
  defaultOptions: {
    weight: undefined
  },
  staticKeys: ['weight']
}), /*#__PURE__*/_dec(_class = (_temp = class BoldExtension extends MarkExtension {
  constructor() {
    super(...arguments);

    _defineProperty(this, "tags", [ExtensionTag.FormattingMark, ExtensionTag.FontStyle]);
  }

  get name() {
    return 'bold';
  }

  createMarkSpec(extra) {
    return {
      attrs: extra.defaults(),
      parseDOM: [{
        tag: 'strong',
        getAttrs: extra.parse
      }, // This works around a Google Docs misbehavior where
      // pasted content will be inexplicably wrapped in `<b>`
      // tags with a font-weight normal.
      {
        tag: 'b',
        getAttrs: node => isElementDomNode(node) && node.style.fontWeight !== 'normal' ? extra.parse(node) : false
      }, {
        style: 'font-weight',
        getAttrs: node => isString(node) && /^(bold(er)?|[5-9]\d{2,})$/.test(node) ? null : false
      }],
      toDOM: node => {
        var weight = this.options.weight;

        if (weight) {
          return ['strong', {
            'font-weight': weight.toString()
          }, 0];
        }

        return ['strong', extra.dom(node), 0];
      }
    };
  }

  createKeymap() {
    return {
      'Mod-b': toggleMark({
        type: this.type
      })
    };
  }

  createInputRules() {
    return [markInputRule({
      regexp: /(?:\*\*|__)([^*_]+)(?:\*\*|__)$/,
      type: this.type,
      ignoreWhitespace: true
    })];
  }

  createCommands() {
    return {
      /**
       * Toggle the bold styling on and off. Remove the formatting if any
       * matching bold formatting within the selection or provided range.
       */
      toggleBold: range => {
        return toggleMark({
          type: this.type,
          range
        });
      },

      /**
       * Set the bold formatting for the provided range.
       *
       * TODO add selection support.
       * TODO add check to see that provided range is valid.
       */
      setBold: range => (_ref) => {
        var tr = _ref.tr,
            dispatch = _ref.dispatch;
        dispatch === null || dispatch === void 0 ? void 0 : dispatch(tr.addMark(range === null || range === void 0 ? void 0 : range.from, range === null || range === void 0 ? void 0 : range.to, this.type.create()));
        return true;
      },

      /**
       * Remove the bold formatting from the provided range.
       *
       * TODO add selection support.
       * TODO add check that the provided range is valid.
       */
      removeBold: range => (_ref2) => {
        var tr = _ref2.tr,
            dispatch = _ref2.dispatch;
        dispatch === null || dispatch === void 0 ? void 0 : dispatch(tr.removeMark(range === null || range === void 0 ? void 0 : range.from, range === null || range === void 0 ? void 0 : range.to, this.type));
        return true;
      }
    };
  }

}, _temp)) || _class);

export { BoldExtension };
